// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** HQ 分页查询全平台订单 GET /api/v1/hq/orders */
export async function HqOrderControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqOrderControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputOrderListItemDtoArray>(
    "/api/v1/hq/orders",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** HQ 查询订单详情 GET /api/v1/hq/orders/${param0} */
export async function HqOrderControllerGetByIdV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqOrderControllerGetByIdV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputOrderDto>(
    `/api/v1/hq/orders/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** HQ 查询订单资产租赁记录 GET /api/v1/hq/orders/${param0}/asset-lease-records */
export async function HqOrderControllerListAssetLeaseRecordsV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqOrderControllerListAssetLeaseRecordsV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputAssetLeaseDtoArray>(
    `/api/v1/hq/orders/${param0}/asset-lease-records`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** HQ 查询订单押金账单 GET /api/v1/hq/orders/${param0}/deposit-payments */
export async function HqOrderControllerListDepositPaymentsV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqOrderControllerListDepositPaymentsV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputPaymentDtoArray>(
    `/api/v1/hq/orders/${param0}/deposit-payments`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** HQ 查询订单分期账单 GET /api/v1/hq/orders/${param0}/installment-payments */
export async function HqOrderControllerListInstallmentPaymentsV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqOrderControllerListInstallmentPaymentsV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputPaymentDtoArray>(
    `/api/v1/hq/orders/${param0}/installment-payments`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** HQ 查询订单追踪记录 GET /api/v1/hq/orders/${param0}/tracking-records */
export async function HqOrderControllerListTrackingRecordsV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqOrderControllerListTrackingRecordsV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputOrderTrackingRecordDtoArray>(
    `/api/v1/hq/orders/${param0}/tracking-records`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** HQ 逾期管理摘要 GET /api/v1/hq/orders/overdue/summary */
export async function HqOrderControllerGetOverdueSummaryV1(
  params: MyApi.HqOrderControllerGetOverdueSummaryV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputHqOverdueSummaryDto>(
    "/api/v1/hq/orders/overdue/summary",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** HQ 逾期管理列表 GET /api/v1/hq/orders/overdue */
export async function HqOrderControllerListOverdueV1(
  params: MyApi.HqOrderControllerListOverdueV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputHqOverdueItemDtoArray>(
    "/api/v1/hq/orders/overdue",
    {
      method: "GET",
      params: {
        pageSize: "10",
        logicOperator: "and",
        sortOrder: "DESC",
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** HQ 查询各 Tab 订单数量 GET /api/v1/hq/orders/count */
export async function HqOrderControllerGetOrderCountV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputOrderCountDto>(
    "/api/v1/hq/orders/count",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** HQ 订单数据看板 GET /api/v1/hq/orders/overview */
export async function HqOrderControllerGetOverviewV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputHqOrderOverviewDto>(
    "/api/v1/hq/orders/overview",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}
